{
  "invalidSelection": "{selectedCount, plural, one {Datos} other {Datų}} pasirinkimas negalimas."
}
